export const SHIFT_UPCOMING = 1;
export const SEGMENT_IN_PROGRESS = 2;
export const SEGMENT_IN_TRANSITION = 3;
export const SHIFT_ENDED = 7;
